var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, InputType } from "type-graphql";
let AssignEntryToPersonInput = class AssignEntryToPersonInput {
    amount;
};
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], AssignEntryToPersonInput.prototype, "amount", void 0);
AssignEntryToPersonInput = __decorate([
    InputType()
], AssignEntryToPersonInput);
export { AssignEntryToPersonInput };
let UpdateFundraisingAssignmentInput = class UpdateFundraisingAssignmentInput {
    amount;
};
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], UpdateFundraisingAssignmentInput.prototype, "amount", void 0);
UpdateFundraisingAssignmentInput = __decorate([
    InputType()
], UpdateFundraisingAssignmentInput);
export { UpdateFundraisingAssignmentInput };
//# sourceMappingURL=fundraisingAccess.js.map